<template>
  <Container type="card-full" v-loading="loading">
    <div slot="header">
      <el-button @click="addOrEdit" type="primary" :loading="btnLoading"
        >保存</el-button
      >
    </div>
    <div>
      <div class="main">
        <el-form
          :model="project"
          ref="ruleForm"
          label-position="right"
          class="mainfrom"
        >
          <div class="from_label_big">
            <div>
              <div class="from_input">
                <div class="row">
                  <el-form-item
                    label="项目编号"
                    prop="projectcode"
                    :verify="validateProjectcode"
                  >
                    <div v-if="+cosInfo.cosprojectcodeflag === 1">
                      {{ project.projectcode }}
                    </div>
                    <div v-else>
                      <el-input
                        v-model="project.projectcode"
                        :maxlength="40"
                      ></el-input>
                    </div>
                  </el-form-item>
                  <el-form-item class="from-value" label="平台编号">
                    <div class="value" style="width: 202px">
                      {{ project.projectno }}
                    </div>
                    <!--<el-input v-model="project.projectno" :maxlength="20" show-word-limit :disabled="true"></el-input>-->
                  </el-form-item>
                  <el-form-item
                    label="所在地区"
                    prop="projectnoticeareacode"
                    verify
                  >
                    <el-select
                      v-model="project.projectnoticeareacode"
                      @change="changeArea"
                    >
                      <el-option
                        v-for="item in areaList"
                        :label="item.label"
                        :value="item.dptareacode"
                        :key="item.dptareaid"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div
                  class="row from-value"
                  v-if="$store.getters.loginUser.comtype == '2'"
                >
                  <el-form-item label="采购人">
                    <div class="value">
                      {{ $store.getters.loginUser.comfullname }}
                    </div>
                  </el-form-item>
                  <el-form-item label="联系人">
                    <div class="value">
                      {{ $store.getters.loginUser.username }}
                    </div>
                  </el-form-item>
                  <el-form-item label="联系方式">
                    <el-input
                      v-model="project.projectptel"
                      :maxlength="60"
                    ></el-input>
                  </el-form-item>
                </div>
                <div v-else class="row">
                  <el-form-item label="采购人" prop="projectpcomid" verify>
                    <!-- <el-select v-model="project.projectpcomid" :filterable="true" :clearable="true"
                               @change="getpUserList">
                      <el-option v-for="(item, index) in pcomList" :label="item.label" :value="item.value"
                                 :key="index"></el-option>
                    </el-select> -->
                    <el-input
                      v-model="project.pcomfullname"
                      :maxlength="20"
                      :disabled="true"
                    ></el-input>
                    <!-- <vxe-button type="primary" @click="showPcom" icon="el-icon-search" style="height:38px;"></vxe-button> -->
                  </el-form-item>

                  <el-form-item label="联系人" prop="projectpuserid" verify>
                    <el-select
                      v-model="project.projectpuserid"
                      :clearable="true"
                      :filterable="true"
                      @change="getpUserTel"
                    >
                      <el-option
                        v-for="(item, index) in puserList"
                        :label="item.label"
                        :value="item.value"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="联系方式" prop="projectptel" verify>
                    <el-input
                      v-model="project.projectptel"
                      :maxlength="60"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="content-title">
                <el-form-item label="项目名称" prop="projectname" verify>
                  <el-input
                    v-model="project.projectname"
                    :maxlength="128"
                    show-word-limit
                    class="projectNameInput"
                  ></el-input>
                </el-form-item>
                <el-form-item label="品目类型" prop="projectpmid" verify>
                  <el-cascader
                    :show-all-levels="false"
                    v-model="pmid"
                    :options="pmTreeList"
                    :props="{ expandTrigger: 'hover' }"
                  ></el-cascader>
                  <!--<el-select v-model="project.projectpmid" filterable placeholder="请选择">-->
                  <!--<el-option-group-->
                  <!--v-for="group in pmTreeList"-->
                  <!--:key="group.value"-->
                  <!--:label="group.label"-->
                  <!--:value="group.value">-->
                  <!--<el-option v-for="item in group.children":key="item.value"-->
                  <!--:label="item.label"-->
                  <!--:value="item.value">-->

                  <!--</el-option>-->
                  <!--</el-option-group>-->
                  <!--</el-select>-->
                </el-form-item>
              </div>
              <div class="from_input">
                <div class="row">
                  <el-form-item label="交易方式" prop="prsflg" verify>
                    <el-select
                      v-model="project.prsflg"
                      @change="prsflgChange"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in projectprsflgList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <!-- <el-form-item label="采购品目" prop="projectpmid" verify>
                    <el-cascader :show-all-levels="false" @change="pmidChange"
                                 v-model="pmid"
                                 :options="pmTreeList"
                                 :props="{ expandTrigger: 'hover' }"
                    ></el-cascader>
                  </el-form-item> -->
                  <el-form-item
                    class="from-value"
                    label="评审方法"
                    prop="projectdoneflg"
                    verify
                  >
                    <!-- <div
                      class="value"
                      v-if="this.project.prsflg"
                      style="width: 204px"
                    >
                      {{ project.projectdoneflgdesc }}
                    </div> -->
                    <!-- <div class="value" v-else-if="this.project.prsflg == '4'  || this.project.prsflg == '5'" style="width:204px;">{{project.projectdoneflgdesc}}</div> -->
                    <el-select
                      v-model="project.projectdoneflg"
                      @change="projectdoneflgChange"
                      :clearable="true"
                    >
                      <el-option
                        v-for="(item, index) in projectdoneflgList"
                        :label="item.label"
                        :value="item.value"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    class="from-value"
                    label="价格计分"
                    prop="projectpricecomputebasis"
                    verify
                  >
                    <div
                      v-if="
                        this.project.prsflg == '4' || this.project.prsflg == '5'
                      "
                    >
                      {{ project.projectpricecomputebasisdesc }}
                    </div>
                    <div v-else>
                      <el-select
                        v-model="project.projectpricecomputebasis"
                        :clearable="true"
                      >
                        <el-option
                          v-for="(item, index) in projectpricecomputebasisList"
                          :label="item.label"
                          :value="item.value"
                          :key="index"
                        ></el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                  <el-form-item
                    v-if="
                      +project.projectpricecomputebasis === 3 ||
                      +project.projectpricecomputebasis === 4
                    "
                    label="平均价浮动率"
                    prop="projectaveragepriceshift"
                    verify
                    comdifyValdate
                  >
                    <el-input
                      v-model="project.projectaveragepriceshift"
                      @blur="inputMoney($event, 'projectlimitamt')"
                      :maxlength="12"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="row" v-if="isScoreEdit">
                      <el-form-item label="履约分值" prop="projectperformancescore"  verify scoreVerify>
                        <el-input @blur="scoreFixed($event, 'projectperformancescore')" v-model="project.projectperformancescore"></el-input>
                      </el-form-item>
                </div>
                <div class="row">
                  <el-form-item
                    :label="`${limitamtNmae}`"
                    prop="projectlimitamt"
                    verify
                    comdifyValdate
                  >
                    <div class="supplynums">
                      <el-input
                        v-model="project.projectlimitamt"
                        @blur="inputMoney($event, 'projectlimitamt')"
                        @change="recalcBmamt"
                        :maxlength="12"
                      >
                        <template slot="append"><span>元</span></template>
                      </el-input>
                      <amount
                        :money="String(project.projectlimitamt)"
                        class="el-form-item__error"
                        v-if="project.projectlimitamt"
                      />
                    </div>
                  </el-form-item>
                  <!-- <el-form-item label="项目预算(最低)" prop="projectlowamt" verify comdifyValdate v-if="+this.project.prsflg === 3 || +this.project.prsflg === 4">
                    <div  class="supplynums">
                      <el-input v-model="project.projectlowamt"
                                @blur="inputMoney($event,'projectlowamt')"
                                :maxlength="12">
                              <template slot="append"><span >元</span></template>
                      </el-input>
                      <amount :money="String(project.projectlowamt)" class="el-form-item__error" v-if="project.projectlowamt"/>
                    </div>
                  </el-form-item> -->
                  <el-form-item :label="`${publicname}`">
                    <div class="checkbox_w" v-if="+project.prsflg === 4">
                      {{ project.projectysflg ? "公开" : "不公开" }}
                    </div>
                    <div class="checkbox_w" v-else>
                      <el-checkbox v-model="project.projectysflg"></el-checkbox>
                    </div>
                  </el-form-item>
                  <el-form-item label="报价含税">
                    <div class="checkbox_w">
                      <el-checkbox v-model="project.projecthsflg"></el-checkbox>
                    </div>
                  </el-form-item>
                  <el-form-item
                    label="报价方式"
                    prop="projectquotationmode"
                    verify
                    v-if="
                      +project.prsflg === 1 ||
                      +project.prsflg === 3 ||
                      +project.prsflg === 6
                    "
                  >
                    <!-- <div class="value">{{project.ausername}}</div> -->
                    <el-select
                      v-model="project.projectquotationmode"
                      @change="quotationmodeChange"
                    >
                      <el-option
                        v-for="(item, index) in quotationList"
                        :label="item.label"
                        :value="item.value"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div
                  class="row from-value"
                  v-if="$store.getters.loginUser.comtype == '1'"
                >
                  <el-form-item label="代理机构">
                    <div class="value" style="width: 209px">
                      {{ project.acomfullname }}
                    </div>
                    <!--<el-select v-model="project.projectacomid" @change="getaUserList">-->
                    <!--<el-option v-for="(item, index) in acomList" :label="item.label" :value="item.value"-->
                    <!--:key="index"></el-option>-->
                    <!--</el-select>-->
                  </el-form-item>
                  <el-form-item label="联系人" prop="projectauserid" verify>
                    <!-- <div class="value">{{project.ausername}}</div> -->
                    <el-select
                      v-model="project.projectauserid"
                      @change="getaUserTel"
                    >
                      <el-option
                        v-for="(item, index) in auserList"
                        :label="item.label"
                        :value="item.value"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="联系方式" prop="projectatel">
                    <!-- <div class="value">{{project.projectatel}}</div> -->
                    <el-input
                      v-model="project.projectatel"
                      :maxlength="60"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="content-title">
                <div class="row">
                  <el-form-item label="采购协议" class="from-value">
                    <div class="value" style="width: 543px">
                      {{ ptcInfo.ptccode }}&nbsp;&nbsp;/&nbsp;&nbsp;{{
                        ptcInfo.ptcname
                      }}
                    </div>
                  </el-form-item>
                  <el-form-item label="业务员" class="from-value">
                    <div
                      class="value"
                      style="width: 220px"
                      v-if="ptcInfo.dptObj"
                    >
                      {{ ptcInfo.dptObj.dptname }}&nbsp;&nbsp;/&nbsp;&nbsp;{{
                        ptcInfo.dptObj.username
                      }}
                    </div>
                  </el-form-item>
                  <!-- <el-form-item label="协议文件" class="from-value">
                        <div style="cursor: pointer;" class="linkstyle" @click="downFile(ptcInfo.appends.appendurl)"><a :src="uploadAddr + ptcInfo.appends.appendurl">{{ptcInfo.appends.appendfilename | toolongOmitted}}</a>
                      </div>
                  </el-form-item> -->
                </div>
              </div>
            </div>
            <el-form-item
              label="项目需求"
              v-if="
                +$store.getters.loginUser.comtype === 1 ||
                +$store.getters.loginUser.comtype === 2
              "
            >
              <!--<upload-file-more :fileList="fileList" :isUplaodFlag="type === 3 ? 0 : 1" folderName="project"-->
              <!--@changed='setfile' text="选择文件"></upload-file-more>-->
              <div style="margin-right: 4px;">
                <el-button type="primary" @click="dialogShowpdemandrec=true">选择需求</el-button>
              </div>
              <div class="file">
                <div class="uploadbtn">
                  <upload-btn @changed="setfile" text="上传附件"></upload-btn>
                  <span>(仅限采购和代理机构内部使用)</span>
                </div>
                
              </div>
            </el-form-item>
                <div v-if="appendList.length" class="filelist" style="margin-left: 110px ;">
                  <div
                    v-for="(item, index) in appendList"
                    :key="index"
                    class="fileitem"
                  >
                    <div class="linkstyle" @click="downFile(item.appendurl, item.appendid)">
                      <a :src="uploadAddr + item.appendurl">{{
                        item.appendfilename | toolongOmitted
                      }}</a>
                    </div>
                    <div class="btn" @click="delappend(item)">
                      <span>删除</span>
                    </div>
                  </div>
                </div>
                <div style="margin-left: 120px;font-size: 16px" v-if="currentDemandrec.demandid" @click="router.push('/jjgl/demandrecView?id=' + currentDemandrec.demandid)">
                    <span class="name">{{currentDemandrec.demandname}}</span><span style="color: red;">(点击查看需求详情)</span>
                </div>
            <div class="split-line"></div>
            <div class="from_input">
              <div class="row">
                <el-form-item label="报名方式" prop="projectisinvite" verify>
                  <div class="radio_w" style="width: 204px">
                    <el-radio-group v-model="project.projectisinvite">
                      <el-radio @change="changeinvite" :label="1"
                        >邀请</el-radio
                      >
                      <el-radio @change="changeinvite" :label="0"
                        >公开</el-radio
                      >
                    </el-radio-group>
                  </div>
                </el-form-item>
                <el-form-item
                  label="报名审核"
                  v-if="+project.projectisinvite !== 1"
                >
                  <div class="checkbox_w" style="width: 204px">
                    <el-checkbox
                      v-model="project.prsbmneedconfirm"
                    ></el-checkbox>
                  </div>
                </el-form-item>
                <el-form-item
                  label="报名数下限"
                  prop="prssupplynums"
                  verify
                  :gt="-1"
                >
                  <div class="supplynums">
                    <el-input
                      v-model="project.prssupplynums"
                      :maxlength="12"
                    ></el-input>
                    <div style="color: red">0表示不受限</div>
                  </div>
                </el-form-item>
                <!-- <div v-if="+this.project.projectdoneflg == 3">
                  <el-form-item class="from-value" label="项目初审">
                    <div class="value">需要</div>
                  </el-form-item>
                </div>
                <div v-else>
                  <el-form-item class="from-value" label="项目初审"  prop="projectisqcheck" verify >
                    <div class="radio_w" >
                        <el-radio-group v-model="project.projectisqcheck">
                          <el-radio :label="1">需要</el-radio>
                          <el-radio :label="2">不需要</el-radio>
                        </el-radio-group>
                    </div>
                  </el-form-item>
                </div> -->
              </div>
              <!-- <div class="row">
                <el-form-item label="制作采购报告">
                  <div class="radio_w" prop="projectjjreportflg" verify>
                    <el-radio v-model="project.projectjjreportflg" :label="1">需要</el-radio>
                    <el-radio v-model="project.projectjjreportflg" :label="0">不需要</el-radio>
                  </div>
                </el-form-item>
              </div> -->
              <!-- <div class="row">
                <el-form-item class="from-value" label="评审方法" prop="projectdoneflg" verify>
                  <div class="value" v-if="this.project.prsflg == '2'">{{project.projectdoneflgdesc}}</div>
                  <el-select v-model="project.projectdoneflg" @change="projectdoneflgChange" :clearable="true"  v-if="this.project.prsflg == '1'">
                      <el-option v-for="(item, index) in projectdoneflgList" :label="item.label" :value="item.value"
                      :key="index"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item class="from-value" label="价格计分"  prop="projectpricecomputebasis" verify>
                  <div>
                    <el-select v-model="project.projectpricecomputebasis" :clearable="true">
                    <el-option v-for="(item, index) in projectpricecomputebasisList" :label="item.label" :value="item.value"
                    :key="index"></el-option>
                    </el-select>
                  </div>
                </el-form-item>
                <el-form-item v-if="+project.projectpricecomputebasis===3 || +project.projectpricecomputebasis===4" label="平均价浮动率" prop="projectaveragepriceshift" verify comdifyValdate>
                  <el-input v-model="project.projectaveragepriceshift"
                            @blur="inputMoney($event,'projectlimitamt')"
                            :maxlength="12"></el-input>
                </el-form-item>
              </div> -->
              <div class="row">
                <el-form-item
                  label="报名费"
                  prop="projectbmamt"
                  verify
                  comdifyValdate
                >
                  <div class="supplynums">
                    <el-input
                      v-model="project.projectbmamt"
                      :maxlength="12"
                      :disabled="bmFeeAuto"
                      @blur="inputMoney($event, 'projectbmamt')"
                      placeholder="0表示免费"
                    ></el-input>
                    <div
                      class="el-form-item__error"
                      v-if="project.projectbmamt"
                    >
                      <amount :money="String(project.projectbmamt)" />
                    </div>
                  </div>
                  <span
                    v-if="bmFeeAuto"
                    style="color: #E6A23C; font-size: 12px;"
                  >（该项目收取报名费，收费标准依据平台收费标准自动计算，不可修改）
                    <el-popover placement="bottom-start" width="360" trigger="click">
                      <div style="font-size: 13px; line-height: 1.9;">
                        <div style="font-weight: bold; margin-bottom: 6px;">平台报名费收费标准</div>
                        <div v-for="(item, index) in bmFeeRules" :key="index"><span>{{ `第${item.levelText}档次，${item.desc}，按照 ` }}</span><span
                            style="color: #E6A23C; font-weight: bold;">{{ item.amount }}元/次</span><span>{{ index < bmFeeRules.length - 1 ? ' 收取；' : ' 收取。' }}</span></div>
                        <div v-if="!bmFeeRules.length" style="color: #909399;">暂未配置收费标准</div>
                      </div>
                      <i slot="reference" class="el-icon-question"
                        style="color: #409EFF; font-size: 16px; cursor: pointer; vertical-align: -2px; margin-left: 4px;"></i>
                    </el-popover>
                  </span>
                </el-form-item>
                <el-form-item
                  v-if="+project.projectbmamt !== 0"
                  label="缴费方式"
                  prop="projectbmpayway"
                  :verify="valiway"
                >
                  <div class="radio_w">
                    <el-radio-group
                      v-model="project.projectbmpayway"
                      v-if="typeENV !== 'production'"
                    >
                      <el-radio :label="1">线上</el-radio>
                      <el-radio :label="2">线下</el-radio>
                      <el-radio :label="3">同时支持</el-radio>
                    </el-radio-group>
                    <span v-else>{{
                      +project.projectbmpayway === 1 ? "线上支付" : "线下支付"
                    }}</span>
                  </div>
                </el-form-item>
              </div>
              <div class="row">
                <el-form-item
                  label="保证金"
                  prop="projectbzjamt"
                  :verify="validateBZJ"
                  comdifyValdate
                >
                  <div class="supplynums">
                    <el-input
                      v-model="project.projectbzjamt"
                      :maxlength="12"
                      @blur="inputMoney($event, 'projectbzjamt')"
                      placeholder="0表示免费"
                    ></el-input>
                    <div
                      class="el-form-item__error"
                      v-if="project.projectbzjamt && bzjistshow"
                    >
                      <amount :money="String(project.projectbzjamt)" />
                    </div>
                  </div>
                </el-form-item>
                <el-form-item
                  v-if="+project.projectbzjamt !== 0"
                  label="缴费方式"
                  prop="projectbzjpayway"
                  :verify="valiway"
                >
                  <div class="radio_w">
                    <el-radio-group
                      v-model="project.projectbzjpayway"
                      v-if="typeENV !== 'production'"
                    >
                      <el-radio :label="1">线上</el-radio>
                      <el-radio :label="2">线下</el-radio>
                      <el-radio :label="3">同时支持</el-radio>
                    </el-radio-group>
                    <span v-else>{{
                      +project.projectbzjpayway === 1 ? "线上支付" : "线下支付"
                    }}</span>
                  </div>
                </el-form-item>
              </div>
              <div class="row">
                <!-- verify -->
                <el-form-item label="报名开始" prop="prsbmbegtime" >
                  <el-date-picker
                    v-model="project.prsbmbegtime"
                    type="datetime"
                    placeholder="选择日期时间"
                    :picker-options="pickerOptions"
                  ></el-date-picker>
                </el-form-item>
                <!-- :verify="validatebmend" -->
                <el-form-item
                  label="报名截止"
                  prop="prsbmendtime"
                >
                  <el-date-picker
                    v-model="project.prsbmendtime"
                    type="datetime"
                    placeholder="选择日期时间"
                    :picker-options="pickerOptions"
                  ></el-date-picker>
                  <!--            <el-checkbox v-model="project.prsbmneedconfirm">报名需要确认</el-checkbox>-->
                </el-form-item>
              </div>
              <div class="row">
                <!-- :verify="validatebjbegin" -->
                <el-form-item
                  :label="`报价开始`"
                  prop="prsbjbegtime"
                >
                  <el-date-picker
                    v-model="project.prsbjbegtime"
                    type="datetime"
                    placeholder="选择日期时间"
                    :picker-options="pickerOptions"
                  ></el-date-picker>
                </el-form-item>
                <!-- :verify="validatebjend" -->
                <el-form-item
                  :label="`报价截止`"
                  prop="prsbjendtime"
                >
                  <el-date-picker
                    v-model="project.prsbjendtime"
                    type="datetime"
                    placeholder="选择日期时间"
                    :picker-options="pickerOptions"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="是否允许截止时间后报价" class="projectdelaypricepermite">
                  <div class="checkbox_w" style="width: 50px">
                    <el-checkbox
                      v-model="project.projectdelaypricepermite"
                    ></el-checkbox>
                  </div>
                </el-form-item>
              </div>
              <div
                v-if="
                  +project.prsflg === 1 ||
                  +project.prsflg === 3 ||
                  +project.prsflg === 6
                "
              >
                <div class="row">
                  <el-form-item
                    label="报价轮次"
                    prop="prsbjtimes"
                    verify
                    :gt="0"
                  >
                    <el-input
                      v-model="project.prsbjtimes"
                      :maxlength="2"
                      :disabled="+this.project.prsflg === 6 ? true : false"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="轮次报价" prop="prsisopen" verify>
                    <el-select v-model="project.prsisopen" :clearable="true">
                      <el-option
                        v-for="(item, index) in prsisopenList"
                        :label="item.label"
                        :value="item.value"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                  label="报价数下限"
                  prop="projectbidderslowerlimit"
                  verify
                  :gt="-1"
                >
                  <div class="supplynums">
                    <el-input
                      v-model="project.projectbidderslowerlimit"
                      :maxlength="12"
                    ></el-input>
                    <div style="color: red">0表示不受限</div>
                  </div>
                </el-form-item>
                  <!-- <el-form-item label="主持人与否" prop="projectneedhost">
                    <div class="checkbox_w">
                      <el-checkbox v-model="project.projectneedhost"></el-checkbox>
                    </div>
                  </el-form-item> -->
                </div>
              </div>
              <!-- <div class="row" v-if="+project.prsflg === 1">
                <el-form-item label="提交竞价方案" prop="projectjjfile" verify>
                  <div class="radio_w" >
                    <el-radio v-model="project.projectjjfile" :label="1">需要</el-radio>
                    <el-radio v-model="project.projectjjfile" :label="0">不需要</el-radio>
                  </div>
                </el-form-item>
              </div> -->
              <div
                class="row"
                v-if="+project.prsflg === 4 || +project.prsflg === 5"
              >
                <el-form-item
                  label="梯度金额"
                  prop="projectgradientamt"
                  verify
                  :gt="0"
                >
                  <el-input
                    v-model="project.projectgradientamt"
                    :maxlength="12"
                  >
                    <template slot="append"><span>元</span></template>
                  </el-input>
                </el-form-item>
                <el-form-item
                  label="自动结束时长(分钟）"
                  prop="prsnmin"
                  verify
                  :gt="0"
                >
                  <!-- <el-input v-model="project.prsnmin" :maxlength="2"></el-input> -->
                  <el-input v-model="project.prsnmin" :maxlength="12">
                    <template slot="append"><span>分钟</span></template>
                  </el-input>
                </el-form-item>
              </div>
              <div class="row">
                <!-- <div v-if="+this.project.projectdoneflg == 3">
                  <el-form-item class="from-value" label="项目初审">
                    <div class="value">需要</div>
                  </el-form-item>
                </div>
                <div v-else>
                  <el-form-item class="from-value" label="项目初审"  prop="projectisqcheck" verify >
                    <div class="radio_w" >
                        <el-radio-group v-model="project.projectisqcheck">
                          <el-radio :label="1">需要</el-radio>
                          <el-radio :label="2">不需要</el-radio>
                        </el-radio-group>
                    </div>
                  </el-form-item>
                </div> -->
                <el-form-item
                  :label="`${
                    +this.project.prsflg === 6 ? '评审文件' : '竞价方案'
                  }`"
                  v-if="
                    +project.prsflg === 1 ||
                    +project.prsflg === 3 ||
                    +project.prsflg === 6
                  "
                >
                  <div class="checkbox_w" style="width: 210px">
                    <el-checkbox
                      :disabled="+project.prsflg === 6 ? true : false"
                      v-model="project.projectjjfile"
                    ></el-checkbox>
                  </div>
                </el-form-item>
                <!-- <div v-if="+this.project.projectdoneflg === 3">
                    <el-form-item class="from-value" label="项目初审">
                      <div class="value" style="width:209px;">需要</div>
                    </el-form-item>
                  </div> -->
                <div>
                  <el-form-item
                    label="项目初审"
                    v-if="+project.prsflg === 1 || +project.prsflg === 3 || +project.prsflg === 6"
                  >
                    <div class="checkbox_w" style="width: 204px">
                      <el-checkbox
                        v-model="project.projectisqcheck"
                        @change="sqcheckChange"
                      ></el-checkbox>
                    </div>
                  </el-form-item>
                </div>
                <el-form-item :label="`${conName}报告`">
                  <div class="checkbox_w" style="width: 204px">
                    <el-checkbox
                      v-model="project.projectjjreportflg"
                    ></el-checkbox>
                  </div>
                </el-form-item>
              </div>
              <div class="row" v-if="$store.getters.loginUser.comtype == '1'">
                <el-form-item label="收费标准" prop="prschangeflg" verify>
                  <el-select v-model="project.prschangeflg" :clearable="true">
                    <el-option
                      v-for="(item, index) in prschangeflgList"
                      :label="item.label"
                      :value="item.value"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  v-if="
                    +project.prschangeflg === 1 || +project.prschangeflg === 3
                  "
                  label="服务类型"
                >
                  <div style="width: 209px">
                    {{ project.chargefeetypedesc }}
                  </div>
                </el-form-item>
                <div v-if="+project.prschangeflg === 2">
                  <el-form-item
                    label="服务收费"
                    prop="prschangefee"
                    verify
                    comdifyValdate
                  >
                    <el-input
                      v-model="project.prschangefee"
                      :maxlength="12"
                      @blur="inputMoney($event, 'prschangefee')"
                    ></el-input>
                    <div
                      class="el-form-item__error"
                      v-if="project.prschangefee"
                    >
                      <amount :money="String(project.prschangefee)" />
                    </div>
                  </el-form-item>
                </div>
                <el-form-item
                  label="缴费方式"
                  prop="projectfeepayway"
                  :verify="valiway"
                  v-if="
                    $store.getters.loginUser.comtype == '1' &&
                    ((+project.prschangefee !== 0 &&
                      +project.prschangeflg === 2) ||
                      +project.prschangeflg === 1 ||
                      +project.prschangeflg === 3)
                  "
                >
                  {{
                    +project.projectfeepayway === 1 ? "线上支付" : "线下支付"
                  }}
                </el-form-item>
              </div>
              <!-- <div class="row" v-if="$store.getters.loginUser.comtype=='1' && (+project.prschangefee !== 0 && +project.prschangeflg === 2 || +project.prschangeflg === 1)">
                <el-form-item label="服务费缴费方式" prop="projectfeepayway" :verify="valiway">
                  <div class="radio_w" >
                    <el-radio-group v-model="project.projectfeepayway">
                      <el-radio :label="1">线上</el-radio>
                      <el-radio :label="2">线下</el-radio>
                      <el-radio :label="3">同时支持</el-radio>
                    </el-radio-group>
                  </div>
                </el-form-item>
              </div> -->
            </div>
            <div class="split-line"></div>
            <div class="content">
              <el-form-item required :label="`${conName}内容`">
                <div
                  ref="editorNR"
                  style="text-align: left; width: 850px"
                ></div>
              </el-form-item>
              <div style="font-size: 14px; color: red; margin-left: 121px">
                {{ prsTSName }}项目详情可见
              </div>
            </div>
            <!-- <div class="split-line"></div>
            <div class="content">
              <el-form-item required label="采购要求">
                <div ref="editorYQ" style="text-align:left;width:850px;"></div>
              </el-form-item>
              <div style="font-size:14px;color:red;margin-left:121px;">{{prsTSName}}项目详情可见</div>
            </div> -->
            <div class="split-line"></div>
            <div class="content">
              <el-form-item label="项目备注">
                <!--t-->
                <el-input
                  show-word-limit
                  :maxlength="255"
                  type="textarea"
                  :rows="5"
                  v-model="project.prsremark"
                ></el-input>
              </el-form-item>
            </div>
            <el-form-item
              v-if="+project.prsflg === 2"
              label="投标模式"
              prop="projectopenbidmode"
              verify
            >
              <div class="radio_w">
                <el-radio
                  v-model="project.projecttenderbidmode"
                  @change="tenderChange"
                  :label="1"
                  >线上投标</el-radio
                >
                <el-radio
                  v-model="project.projecttenderbidmode"
                  @change="tenderChange"
                  :label="2"
                  v-if="project.projectopenbidmode != 2"
                  >线下投标</el-radio
                >
              </div>
            </el-form-item>
            <el-form-item
              v-if="+project.prsflg === 2"
              label="开标模式"
              prop="projectopenbidmode"
              verify
            >
              <div class="radio_w">
                <el-radio
                  v-model="project.projectopenbidmode"
                  @change="openbidmodeChange"
                  :label="1"
                  >现场开标</el-radio
                >
                <el-radio
                  v-model="project.projectopenbidmode"
                  @change="openbidmodeChange"
                  v-if="project.projecttenderbidmode != 2"
                  :label="2"
                  >远程开标</el-radio
                >
              </div>
            </el-form-item>
            <div v-if="+project.prsflg === 2">
              <el-form-item :label="`${prsflgName}地址`">
                <el-input
                  v-model="project.projectbidaddr"
                  :maxlength="255"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </div>
            <el-form-item
              :label="prsflgName + '文件'"
              v-if="
                +$store.getters.loginUser.comtype === 1 ||
                +$store.getters.loginUser.comtype === 2
              "
            >
              <!--<upload-file-more :fileList="fileList" :isUplaodFlag="type === 3 ? 0 : 1" folderName="project"-->
              <!--@changed='setfile' text="选择文件"></upload-file-more>-->
              <div style="display: flex;flex-direction:row">
                <div class="file">
                <div class="uploadbtn">
                  <upload-btn
                    @changed="setfile_zb"
                    :text="'上传' + prsflgName + '文件'"
                  ></upload-btn>
                  <div style="color: red">
                    （用于报名的供应商下载，也可在发布项目公告时上传。）
                  </div>
                </div>
                <div v-if="appendList_zb.length" class="filelist">
                  <div
                    v-for="(item, index) in appendList_zb"
                    :key="index"
                    class="fileitem"
                  >
                    <div class="linkstyle" @click="downFile(item.appendurl)">
                      <a :src="uploadAddr + item.appendurl">{{
                        item.appendfilename | toolongOmitted
                      }}</a>
                    </div>
                    <div class="btn" @click="delappend_zb(item)">
                      <span>删除</span>
                    </div>
                  </div>
                </div>
              </div>
              <el-form-item label="公告中是否可见" style="margin-left: 5px;">
                    <div class="checkbox_w">
                      <el-checkbox v-model="projectpfvisibleVal"></el-checkbox>
                    </div>
                </el-form-item>
              </div>
          
            </el-form-item>
          </div>
        </el-form>
        <el-dialog
          title="选择采购人"
          :visible.sync="dialogShowpcom"
          width="50%"
        >
          <div style="margin-bottom: 20px">
            <el-input
              style="width: 80%; margin-right: 20px"
              @input="inputchange"
              @change="searchCGR"
              v-model="comname"
              placeholder="请输入采购人名称"
              clearable
            />
            <el-button type="primary" @click="searchCGR">搜索</el-button>
          </div>
          <vggrid
            :list="pcomList"
            tableheight="600"
            flexname=""
            :cols="cols"
            :showfooter="false"
            :showPage="true"
            :resizable="true"
            :total="query.total"
            @pagechange="pagechange"
          >
          </vggrid>
        </el-dialog>
      </div>
    </div>
    <el-dialog 
        title="选择采购需求"
        :visible.sync="dialogShowpdemandrec"
        width="80%">
        <div>
          <div class="search">
          <div class="search_box">
            <div class="searchItem">
              <div class="label">需求编号</div>
              <div class="field">
                <el-input v-model.trim="demandrecQuery.demandcode" clearable></el-input>
              </div>
            </div>
            <div class="searchItem">
              <div class="label">需求名称</div>
              <div class="field">
                <el-input v-model.trim="demandrecQuery.demandname" clearable></el-input>
              </div>
            </div>
            <div class="searchItem">
              <div class="label">下达日期</div>
              <div class="field" style="width: 400px">
                <el-date-picker v-model="demandrecQuery.begTime" type="date" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" placeholder="选择日期"> </el-date-picker>
                <div style="margin: 0 10px">至</div>
                <el-date-picker v-model="demandrecQuery.endTime" type="date" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" placeholder="选择日期"> </el-date-picker>
              </div>
            </div>
            <div class="searchItem" style="justify-content: flex-end;width: 100%; margin-right: 10px;">
              <div class="search_btn">
                <el-button type="primary" @click="search">查询</el-button>
              </div>
            </div>
          </div>
        </div>
        <vxe-table border highlight-hover-row align="content-center" @cell-dblclick="cellClickEvent" :loading="demandrecLoading" :data="demandrecList">
          <vxe-table-column header-align="center" field="projectcode" title="需求编号" width="160">
            <template v-slot="{ row }">
              {{ row.demandcode }}
            </template>
          </vxe-table-column>
          <vxe-table-column header-align="center" field="projectname" title="需求名称" width="240">
            <template v-slot="{ row }">
              <span class="name" @click="router.push('/jjgl/demandrecView?id=' + row.demandid)"> {{ row.demandname }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column header-align="center" field="sex" title="采购人">
            <template v-slot="{ row }">
              {{ row.comfullname }}
            </template>
          </vxe-table-column>
          <vxe-table-column header-align="center" field="sex" title="经办人">
            <template v-slot="{ row }">
              {{ row.demandcreateusername }}
            </template>
          </vxe-table-column>
          <vxe-table-column header-align="center" field="comfullname" title="下达日期" width="160">
            <template v-slot="{ row }">
              {{ row.demandsubmittime ? formatTime(row.demandsubmittime) : '' }}
            </template>
          </vxe-table-column>
          <vxe-table-column header-align="center" field="comfullname" title="建项" width="80">
            <template v-slot="{ row }">
              {{ +row.projectcount === 0 ? '未建项' : '已建项' }}
            </template>
          </vxe-table-column>
          <vxe-table-column header-align="center" title="操作" width="89">
            <template v-slot="{ row }">
              <vxe-button type="text" @click="handleCurrentDeamndrec(row)"  status="primary" content="确认"></vxe-button>
            </template>
          </vxe-table-column>
        </vxe-table>
        <vxe-pager
          :loading="loading"
          :page-sizes="[5, 10, 20, 50, 100]"
          :current-page="demandrecQuery.currentPage"
          :page-size="demandrecQuery.pageSize"
          :total="demandrecQuery.total"
          :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
          @page-change="handleDemandrecPageChange"
        ></vxe-pager>
      </div>
  </el-dialog>
  </Container>
</template>

<script>
import request from "@/utils/request";
import utils from "../../assets/js/utils";
import uploadBtn from "../common/uploadBtn";
import config from "../../assets/config";
import common from "@/mixin/common";
import _ from "lodash";
import E from "wangeditor";
import dayjs from "dayjs";
import amount from "../common/amount";
import vggrid from "../common/vggrid";
import env from "../../../src/assets/config";

const SUCCESS = 1;
export default {
  name: "projectEdit",
  mixins: [common],
  data() {
    return {
      router: this.$router,
      dialogShowpdemandrec: false,
      envType: "", //环境
      isBmFeePurchaser: false, //采购人是否在“收报名费”名单（白名单）内
      bmFeeRules: [], //平台报名费收费标准（弹窗展示用）
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() <= Date.now() - 86400000;
        },
      },
      comname: "",
      ptcInfo: {
        appends: {},
      },
      project: {
        projectcode: "",
        projectauserid: "",
        projectacomid: "",
        projectatel: "",
        projectpuserid: "",
        projectpcomid: "",
        projectptel: "",
      },
      projectpfvisibleVal: false,
      dialogShowpcom: false,
      cols: [
        {
          type: "index",
          fieldtype: "I",
          title: "行号",
          calculExpr: "",
          width: 50,
        },
        {
          field: "comfullname",
          fieldtype: "C",
          title: "采购人",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          title: "操作 ",
          showOverflow: true,
          slots: {
            default: ({ row }) => {
              return [
                <vxe-button
                  type="primary"
                  onClick={this.confirmCom.bind(this, row)}
                >
                  确认
                </vxe-button>,
              ];
            },
          },
        },
      ],
      // type: Number(this.$route.params.type),
      appendList: [],
      appendList_zb: [],
      pmList: [],
      pmTreeList: [],
      puserList: [],
      auserList: [],
      projectprsflgList: [],
      prschangeflgList: [],
      projectpricecomputebasisList: [],
      // copy:[], // 评审方法复制对象
      // copy_val:[], // 评审方法复制对象二
      // copy_val_o:[],
      // copy_val_p:[],
      projectdoneflgList: [],
      prsisopenList: [],
      chargefeetypeList: [],
      quotationList: [],
      acomList: [],
      pcomList: [],
      btnLoading: false,
      comsuserList: [],
      comList: {},
      pmid: "",
      editorNRDesc: "",
      editorYQContent: "",
      editorNR: "",
      editorYQ: "",
      addr: "",
      cosInfo: {},
      bzjistshow: true,
      query: {
        comneme: "",
        total: 0,
        limit: 20,
        offset: 0,
      },
      currentDemandrec: {},
      demandrecQuery: {
        total: 0,
        limit: 10,
        offset: 0,
        currentPage: 1,
        pageSize: 10
      },
      demandrecLoading: false,
      demandrecList: [],
      loading: false,
      areaList: [],
      typeENV: this.$dev,
    };
  },
  components: { uploadBtn, amount, vggrid },
  filters: {
    toolongOmitted(val) {
      if (val) {
        if (val.length > 20) {
          return val.substring(0, 10) + "..." + val.substring(val.length - 4);
        } else {
          return val;
        }
      }
      return val;
    },
  },
  created() {
    // console.log('-------this.$dev---------',this.$dev);
    // this.getModel()
  },
  deactivated() {
    this.$destroy();
  },
  mounted() {},
  async activated() {
    await this.init();
    await this.getCosList();
    await this.getPmList();
    await this.getQuotation();
    // await this.getModel()
    // await this.getPcomList()
    await this.getAcomList();
    await this.getcomsuserList();
    await this.getcomList();
    await this.getPrsflgList();
    await this.getprschangeflgList();
    // await this.getpricecomputebasisList()
    await this.getPrsisopenList();
    await this.getProjectdoneflgList();
    // await this.getChargefeetypeList()
    await this.initEditorNR();
    // await this.initEditorYQ()
    await this.getareaList();
    await this.loadFeeRules();
    await this.loadBmFeeRule();
  },
  computed: {
    isScoreEdit () {
        if (+this.project.prsflg === 1 || +this.project.prsflg === 3 || +this.project.prsflg === 4 || +this.project.prsflg === 5) {
          if (+this.project.projectdoneflg === 4) { 
            return true
          }
        } else if(+this.project.prsflg === 2 || +this.project.prsflg === 6){ 
          if (+this.project.projectdoneflg === 5) { 
            return true
          }
        } else {
          return false
        }
      },
    // 报名费是否自动计算（不可填写）：采购人在“收报名费”名单内 且 项目预算≥1000元
    bmFeeAuto() {
      if (!this.isBmFeePurchaser) return false;
      const amt = this.project.projectlimitamt ? utils.delcommafy(this.project.projectlimitamt) : 0;
      return Number(amt) >= 1000;
    },
    uploadAddr() {
      return this.$store.getters.uploadAddr;
    },
    prsflgName() {
      if (this.project.prsflg == "2") {
        return "开标";
      } else if (this.project.prsflg == "1" || this.project.prsflg == "3") {
        return "竞价";
      } else if (this.project.prsflg == "4" || this.project.prsflg == "5") {
        return "竞拍";
      } else if (this.project.prsflg == "6") {
        return "比选";
      }
    },
    limitamtNmae() {
      if (this.project.prsflg == "3" || this.project.prsflg == "4") {
        return "项目底价";
      } else {
        return "项目预算";
      }
    },
    publicname() {
      if (this.project.prsflg == "4" || this.project.prsflg == "3") {
        return "底价公开";
      } else {
        return "预算公开";
      }
    },
    prsTSName() {
      if (this.project.prsflg == "2") {
        return "投标人";
      } else if (this.project.prsflg == "1" || this.project.prsflg == "3") {
        return "竞价";
      } else if (this.project.prsflg == "4" || this.project.prsflg == "5") {
        return "竞拍";
      } else if (this.project.prsflg == "6") {
        return "比选";
      }
    },
    conName() {
      if (this.project.prsflg == "4" || this.project.prsflg == "5") {
        return "竞拍";
      } else if (this.project.prsflg == "6") {
        return "比选";
      } else if (this.project.prsflg == "2") {
        return "评标";
      } else {
        return "竞价";
      }
    },
    // lowortop(){
    //   if (this.project.prsflg == '1') {
    //     return '轮次最低价'
    //   } else {
    //     return '轮次最高价'
    //   }
    // }
    // prsflgNameFile(){
    //   if (this.project.prsflg == '2') {
    //     return '招标文件'
    //   } else if (this.project.prsflg == '1') {
    //     return '竞价附件'
    //   }
    // }
  },
  methods: {
    cellClickEvent ({row}) {
      this.router.push('/jjgl/demandrecView?id=' + row.demandid)
    },
    search () {
      this.demandrecQuery.offset = 0
      this.getDemandrecList()
    },
    async handleCurrentDeamndrec (row) {
      this.$confirm('是否确认选择该需求?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.currentDemandrec = row
        if (!!row.demandbudgetamt) this.project.projectlimitamt = row.demandbudgetamt
        else this.project.projectlimitamt = null
        this.project.projectname = row.demandname
        this.project.projectdemandid = row.demandid
        this.project.projectpuserid = row.demandcreateuserid
        this.getpUserTel(row.demandcreateuserid)
        this.dialogShowpdemandrec = false
      })
    },
    async handleDemandrecPageChange({ currentPage, pageSize }) {
      this.demandrecQuery.offset = pageSize * (currentPage - 1)
      this.demandrecQuery.limit = pageSize
      this.demandrecQuery.currentPage = currentPage
      this.demandrecQuery.pageSize = pageSize
      await this.getDemandrecList()
    },
    formatTime(value) {
      return dayjs(value).format('YYYY-MM-DD')
    },
    async getDemandrecList() {
      this.demandrecLoading = true
      this.demandrecQuery.cosid = this.$store.getters.loginUser.cosid
      this.demandrecQuery.userid = this.$store.getters.loginUser.userid
      this.demandrecQuery.demandstatus = -2
      this.demandrecQuery.demandcomid = this.project.projectpcomid
      let res = await request({
        method: 'get',
        url: '/xtgl/demandrec/getRolePageList',
        params: this.demandrecQuery,
      })
      this.demandrecList = [].concat(res.list)
      this.demandrecQuery.total = res.count[0].count
      this.demandrecLoading = false
    },
    scoreFixed (el, name) {
        let inputVal = el.target.value || ''
        this.project[name] = Number(inputVal).toFixed(2)
    },
    async openbidmodeChange(val) {
      if (val === 2 && +this.project.projecttenderbidmode === 2) {
        this.$message.warning("线下投标不能选择远程开标");
        this.project.projectopenbidmode = "";
        return;
      }
      if (val === 2) {
        this.project.projectbidaddr = "本项目远程开标";
      } else {
        this.project.projectbidaddr = this.addr;
      }
    },
    async tenderChange(val) {
      if (val === 2 && +this.project.projectopenbidmode === 2) {
        this.$message.warning("远程开标不能选择线下投标");
        this.project.projecttenderbidmode = "";
        return;
      }
    },
    async pmidChange(val) {
      if (val.length > 1) {
        this.project.projectpmid = val[val.length - 1];
      } else {
        this.project.projectpmid = val;
      }
      let pmModel = this.pmList.find(
        (v) => +v.pmid === +this.project.projectpmid
      );
      if (pmModel) {
        // this.project.projectchargefeetype = pmModel.pmchargefeetype
        await this.getChargefeetypeList();
        let chargefeetypeModel = this.chargefeetypeList.find(
          (v) => +v.syscodeval === +pmModel.pmchargefeetype
        );
        if (chargefeetypeModel) {
          this.project.chargefeetypedesc = chargefeetypeModel.syscodename;
        }
      }
    },
    async prsflgChange(val) {
      console.log(+this.project.prsflg, '+this.project.prsflg')
      console.log(val, '-------')
      this.project.prsbjbegtime = "";
      this.project.prsbjendtime = "";
      this.project.projectlowamt = null;
      if (val !== "6") {
        console.log(+this.project.projectisqcheck, 'this.project.projectisqcheck')
        if (+this.project.projectisqcheck !== 1)   this.project.projectisqcheck = false;
        // this.project.projectjjfile = false;
        this.project.prsbjtimes = 1;
      } else {
        this.project.prsbjtimes = 1;
      }
      if (+val === 1 || +val === 3) {
        this.project.projectjjfile = true
      }
      await this.getpricecomputebasisList();

      if (+this.project.prsflg !== 1 || +this.project.prsflg !== 3) {
         console.log(+this.project.projectisqcheck, 'this.project.projectisqcheck22')
        if (+this.project.projectisqcheck !== 1)   this.project.projectisqcheck = false;
        // this.project.projectisqcheck = 1;
      }

      if (+this.project.prsflg === 1) {
        this.project.projectpricecomputebasis =
          this.projectpricecomputebasisList[0].value;
      } else if (+this.project.prsflg === 3) {
        this.project.projectpricecomputebasis =
          this.projectpricecomputebasisList[0].value;
      } else if (+this.project.prsflg === 6) {
        //综合必选
        this.project.projectpricecomputebasis =
          this.projectpricecomputebasisList[0].value;
        this.project.projectjjfile = true;
      } else if (+this.project.prsflg === 4 || +this.project.prsflg === 5) {
        if (+this.project.prsflg === 4) {
          this.$set(
            this.project,
            "projectpricecomputebasisdesc",
            this.projectpricecomputebasisList[1].label
          );
        } else {
          // this.project.projectpricecomputebasis = this.projectpricecomputebasisList[0].value
          this.$set(
            this.project,
            "projectpricecomputebasisdesc",
            this.projectpricecomputebasisList[0].label
          );
        }
      }
      this.getProjectdoneflgList();
      this.project.projectquotationmode = "1";
      this.getQuotation();
    },
    async projectdoneflgChange(val) {
      this.$set(this.project, "projectpricecomputebasis", "");
      console.log(val, '+++val')
      if (+val === 3) {
        if (+this.project.projectisqcheck !== 1)   this.project.projectisqcheck = false; 
        // this.project.projectisqcheck = 1;
        this.$refs["ruleForm"].clearValidate();
        this.projectpricecomputebasisList = copy_val_p;
      }
      if (+val === 1) {
        if (+this.project.projectisqcheck !== 1)   this.project.projectisqcheck = false; 
        // this.project.projectisqcheck = "";
        this.projectpricecomputebasisList = this.copy_val_o;
      }
      await this.getpricecomputebasisList();
      this.$set(this.project, "projectpricecomputebasis", this.projectpricecomputebasisList[0].value);
      // if(+val === 3){
      //   this.project.projectisqcheck = ""
      //   this.projectpricecomputebasisList = this.copy_val_o
      // }
    },
    async getCosList() {
      let res = await request({
        method: "get",
        url: "/ywgl/cos/getCosbyid",
        params: { cosid: this.$store.getters.loginUser.cosid },
      });
      this.cosInfo = res[0];
    },
    async getModel() {
      this.loading = true;
      let res = await request({
        method: "get",
        url: "/xmgl/project/findProjectById",
        params: { projectid: this.$route.params.projectid },
      });
      this.project = res;
      if (!!this.project.projectdemandid) {
        this.currentDemandrec.demandid = this.project.demandid
        this.currentDemandrec.demandname = this.project.demandname
      }
      this.projectpfvisibleVal = Boolean(this.project.projectpfvisible)
      this.project.projectdelaypricepermite = this.project.projectdelaypricepermite === 0 ? true : false
      this.pmid = +this.project.projectpmid;
      this.project.projectquotationmode =
        this.project.projectquotationmode.toString();
      this.project.projectysflg =
        +this.project.projectysflg === 1 ? true : false;
      this.project.projecthsflg =
        +this.project.projecthsflg === 1 ? true : false;
      this.project.projectneedhost =
        +this.project.projectneedhost === 1 ? true : false;
      this.project.prsbmneedconfirm =
        +this.project.prsbmneedconfirm === 1 ? true : false;
      this.project.projectjjfile =
        +this.project.projectjjfile === 1 ? true : false;
      this.project.projectisqcheck =
        +this.project.projectisqcheck === 1 ? true : false;
      this.project.projectjjreportflg =
        +this.project.projectjjreportflg === 1 ? true : false;
      this.editorNRDesc = this.project.projectdesc;
      this.editorYQContent = this.project.prscontents;
      this.appendList = this.project.appendList;
      this.appendList_zb = this.project.appendList_zb;
      this.addr = this.project.projectbidaddr;
      this.project.projectlimitamt = this.project.projectlimitamt
        ? utils.comdify(utils.delcommafy(this.project.projectlimitamt))
        : this.project.projectlimitamt;
      this.project.projectbmamt = this.project.projectbmamt
        ? utils.comdify(utils.delcommafy(this.project.projectbmamt))
        : this.project.projectbmamt;
      this.project.projectbzjamt = this.project.projectbzjamt
        ? utils.comdify(utils.delcommafy(this.project.projectbzjamt))
        : this.project.projectbzjamt;
      this.project.prschangefee = this.project.prschangefee
        ? utils.comdify(utils.delcommafy(this.project.prschangefee))
        : this.project.prschangefee;
      // console.log('==parseFloat(this.project.projectbmamt)==',parseFloat(this.project.projectbmamt));
      this.project.projectbmamt = this.subZeroAndDot(this.project.projectbmamt);
      this.project.projectbzjamt = this.subZeroAndDot(
        this.project.projectbzjamt
      );
      if (this.project.projectpricecomputebasis) {
        this.project.projectpricecomputebasis =
          this.project.projectpricecomputebasis.toString();
      }
      // this.$set(this.project,'projectpricecomputebasis',this.project.projectpricecomputebasis)
      // this.project.projectisqcheck  = Number(this.project.projectisqcheck)
      this.project.projectisqcheck = this.project.projectisqcheck;
      this.project.projectbmpayway = 1; //报名费线上支付
      this.project.projectbzjpayway = 1; //保证金线上支付
      this.project.projectfeepayway = 2; //服务费线下支付
      await this.getPtcInfo(this.project.projectptcid); //协议
      await this.getpricecomputebasisList();
      if (+this.project.prsflg !== 6) {
        // this.project.prsbjtimes = 0
      } else {
        this.project.prsbjtimes = 1;
      }
      // if (+this.project.projectdoneflg === 3) {
      //   this.projectpricecomputebasisList = this.copy
      //   this.$forceUpdate()
      // }
      // if(+this.project.projectdoneflg === 1){
      //   this.projectpricecomputebasisList = this.copy_val_o
      //   this.$forceUpdate()
      // }
      // if(+this.project.prsflg === 1){
      //   this.projectpricecomputebasisList = this.copy_val_o
      // }
      // else if(+this.project.prsflg === 3){
      //   this.projectpricecomputebasisList = this.copy_val_p
      // }
      this.loading = false;
    },
    subZeroAndDot(s) {
      if (s) {
        s = s.toString();
        if (s.indexOf(".") > 0) {
          s = s.replace(/0+?$/, ""); //去掉多余的0
          s = s.replace(/[.]$/, ""); //如最后一位是.则去掉
        }
      }
      return s;
    },
    async initEditorNR() {
      // this.project.projectcode = this.project.projectno
      if (this.editorNR && this.project.projectdesc) {
        this.editorNR.txt.html(this.project.projectdesc);
        return;
      }
      this.editorNR = new E(this.$refs.editorNR);
      this.editorNR.config.onchange = (html) => {
        this.editorNRDesc = html;
        html === "<p><br></p>" && (this.editorNRDesc = "");
      };
      this.editorNR.config.uploadFileName = "file";
      this.editorNR.config.uploadImgServer = `${config.baseUrl}upload/upload`;
      this.editorNR.config.zIndex = 1;
      this.editorNR.create();
      if (this.project.projectdesc) {
        this.editorNR.txt.html(this.project.projectdesc);
      }
    },
    async initEditorYQ() {
      if (this.editorYQ && this.project.prscontents) {
        this.editorYQ.txt.html(this.project.prscontents);
        return;
      }
      this.editorYQ = new E(this.$refs.editorYQ);
      this.editorYQ.config.onchange = (html) => {
        this.editorYQContent = html;
      };
      this.editorYQ.config.uploadFileName = "file";
      this.editorYQ.config.uploadImgServer = `${config.baseUrl}upload/upload`;
      this.editorYQ.config.zIndex = 1;
      this.editorYQ.create();
      if (this.project.prscontents) {
        this.editorYQ.txt.html(this.project.prscontents);
      }
    },
    validatebmend(rule, val, callback) {
      let start = dayjs(val);
      let end = dayjs(this.project.prsbmbegtime);
      // console.log(
      //   "-------dayjs(v--------",
      //   start.month() - end.month(),
      //   start.date() - end.date()
      // );
      // if (start.month() - end.month() <= 0 && start.date() - end.date() < 2) {
      //   callback(Error("报名结束不能小于等于报名开始"));
      // } else {
      //   callback();
      // }
      if (start.valueOf() <= end.valueOf()) {
        callback(Error("报名结束不能小于等于报名开始"));
      }  else if (start.year() !== end.year()) {
        let min = 31 - (+end.date())
        if (+start.month() !== 0) {
          callback(Error("不能小于三天，请与平台管理员联系"));
        }
        else if (min + start.date() >= 2) {
          callback();
        } else {
          callback(Error("不能小于三天，请与平台管理员联系"));
        }
      }  
      else if (
        start.month() - end.month() <= 0 &&
        start.date() - end.date() < 2
      ) {
        callback(Error("不能小于三天，请与平台管理员联系"));
      } else {
        callback();
      }
    },
    validatebjbegin(rule, val, callback) {
      if (dayjs(val).valueOf() <= dayjs(this.project.prsbmendtime).valueOf()) {
        callback(Error("报价开始不能小于等于报名结束"));
      } else {
        callback();
      }
    },
    validatebjend(rule, val, callback) {
      if (dayjs(val).valueOf() <= dayjs(this.project.prsbjbegtime).valueOf()) {
        callback(Error("报价结束不能小于等于报价开始"));
      } else {
        callback();
      }
    },
    validateProjectcode(rul, val, callback) {
      this.project.projectcode = _.trim(val);
      this.validateData(
        "项目编号不能重复",
        "projectrec",
        "projectid",
        "projectcode",
        val,
        callback
      );
    },
    validateData(msg, tablename, fieldid, checkfield, checkval, callback) {
      request({
        url: "/validate/validateData",
        method: "post",
        data: {
          tablename,
          fieldid,
          checkfield,
          checkval: this.project[checkfield],
          id: this.project.projectid,
        },
      }).then((res) => {
        console.log(res, 90900);
        res === SUCCESS ? callback(Error(msg)) : callback();
      });
    },
    inputMoney(el, name) {
      let val = utils.delcommafy(el.target.value);
      var reg = /^[0-9]+.?[0-9]*$/;
      if (reg.test(val)) {
        this.project[name] = utils.getInputValue(el);
      }
    },
    changeinvite(val) {
      if (val === 1) {
        this.project.prsbmneedconfirm = false;
      }
    },
    async showPcom() {
      this.dialogShowpcom = true;
      this.getSearchPcomList();
    },
    async getSearchPcomList() {
      this.query.cosid = this.$store.getters.loginUser.cosid;
      this.query.comtype = "2";
      //代理单位
      if (this.$store.getters.loginUser.comtype === "1") {
        this.query.comid = null;
      }
      //采购人
      if (this.$store.getters.loginUser.comtype === "2") {
        this.query.comid = this.$store.getters.loginUser.usercomid;
      }
      this.query.comcodename = this.comname;

      let res = await request({
        method: "get",
        url: "/ywgl/com/getPageList",
        params: this.query,
      });
      this.pcomList = res.list;
      this.query.total = res.count[0].count;
    },
    async confirmCom(row) {
      this.project.pcomfullname = row.comfullname;
      this.project.projectpcomid = row.comid;
      await this.getconfimpUserList(row.comid);
      this.dialogShowpcom = false;
    },
    async pagechange(page) {
      this.query.offset = page.pageSize * (page.currentPage - 1);
      this.query.limit = page.pageSize;
      this.getSearchPcomList();
    },
    async searchCGR() {
      this.getSearchPcomList();
    },
    async init() {
      this.envType = env.NODE_ENV;
      await this.getModel();
      // this.editorNRDesc = ''
      // this.editorYQContent = ''
      // this.editorNR = ''
      // this.editorYQ = ''
      this.btnLoading = false;
      if (!this.project.projectid) {
        this.project.projectno = await request({
          url: "/xmgl/project/genProjectNo",
          method: "post",
          data: { cosid: this.$store.getters.loginUser.cosid, genflg: 0 },
        });
        // this.project.projectcode = this.project.projectno
      }

      if (
        this.project.projectid &&
        this.$store.getters.loginUser.comtype == "2"
      ) {
        // // 自采默认采购人和人
        this.project.projectpcomid = this.$store.getters.loginUser.comid;
        this.project.projectpuserid = this.$store.getters.loginUser.userid;
        this.project.projectptel = this.project.projectptel;
      }
      if (this.project.projectpcomid) {
        await this.getpUserList(this.project.projectpcomid);
        this.project.projectpusername = this.$store.getters.loginUser.username;
      }

      if (
        this.project.projectid &&
        this.$store.getters.loginUser.comtype == "1"
      ) {
        this.project.projectacomid = this.$store.getters.loginUser.comid;
        this.project.acomfullname = this.$store.getters.loginUser.comfullname;
        // this.project.projectauserid = this.$store.getters.loginUser.userid
        // this.$set(this.project,'projectauserid',this.$store.getters.loginUser.userid)
        this.project.ausername = this.$store.getters.loginUser.username;
        this.project.projectatel = this.project.projectatel;
      }
      if (this.project.projectacomid) {
        await this.getaUserList(this.project.projectacomid);
      }
    },
    //报价方式更改
    async quotationmodeChange(value) {
      this.project.projectquotationmode = value;
      this.$forceUpdate();
    },
    //报价方式
    async getQuotation() {
      let res = await request({
        url: "/kfgl/syscode/getSysCodeList",
        method: "get",
        params: { syscode: "quotationmode" },
      });
      if (+this.project.prsflg === 1 || +this.project.prsflg === 6) {
        res = res.filter((e) => e.syscodeseq !== 2);
      } else if (+this.project.prsflg === 3) {
        res = res.filter((e) => e.syscodeseq !== 3 && e.syscodeseq !== 4);
      }
      this.quotationList = res;
    },
    async getprschangeflgList() {
      this.prschangeflgList = await request({
        url: "/kfgl/syscode/getSysCodeList",
        method: "get",
        params: { syscode: "prschangeflg" },
      });
    },
    async getpricecomputebasisList() {
      let res = await request({
        url: "/kfgl/syscode/getSysCodeList",
        method: "get",
        params: { syscode: "projectpricecomputebasis" },
      });
      this.projectpricecomputebasisList = res;
      if (+this.project.prsflg === 1) {
        this.projectpricecomputebasisList = res.filter((e) => {
          return +e.value !== 6 && +e.value !== 5;
        });
        // this.project.projectpricecomputebasis = this.projectpricecomputebasisList[0].value
        // this.project.projectpricecomputebasis = this.projectpricecomputebasisList[0].value
      } else if (+this.project.prsflg === 3) {
        this.projectpricecomputebasisList = res.filter((e) => {
          return +e.value !== 6 && +e.value !== 1;
        });
        // this.project.projectpricecomputebasis = this.projectpricecomputebasisList[0].value
        // this.project.projectpricecomputebasis = this.projectpricecomputebasisList[1].value
      } else if (+this.project.prsflg === 6) {
        //综合必选
        this.projectpricecomputebasisList = res.filter((e) => {
          return +e.value !== 6;
        });
        // this.project.projectpricecomputebasis = this.projectpricecomputebasisList[0].value
        this.project.projectjjfile = true;
        // this.project.projectpricecomputebasis = this.projectpricecomputebasisList[0].value
      } else if (+this.project.prsflg === 4 || +this.project.prsflg === 5) {
        this.projectpricecomputebasisList = res.filter((e) => {
          return +e.value !== 6 && +e.value !== 2;
        });
        if (+this.project.prsflg === 4) {
          this.$set(
            this.project,
            "projectpricecomputebasisdesc",
            this.projectpricecomputebasisList[1].label
          );
        } else {
          // this.project.projectpricecomputebasis = this.projectpricecomputebasisList[0].value
          this.$set(
            this.project,
            "projectpricecomputebasisdesc",
            this.projectpricecomputebasisList[0].label
          );
        }
      }
      // this.projectpricecomputebasisList = res
      // this.copy =  _.cloneDeep(res)
      // this.copy_val = _.cloneDeep(res)
      // this.copy_val_o = _.cloneDeep(res)
      // this.copy_val_p = _.cloneDeep(res)
      // this.copy_val.pop()
      // this.copy_val_o.pop()
      // this.copy_val_o.pop()
      // this.copy_val_p.pop()
      // this.copy_val_p.splice(0,1)
    },
    async getPrsflgList() {
      this.projectprsflgList = await request({
        url: "/kfgl/syscode/getSysCodeList",
        method: "get",
        params: { syscode: "prsflg" },
      });
    },
    async getPrsisopenList() {
      this.prsisopenList = await request({
        url: "/kfgl/syscode/getSysCodeList",
        method: "get",
        params: { syscode: "prsisopen" },
      });
    },
    async getProjectdoneflgList() {
      let res = await request({
        url: "/kfgl/syscode/getSysCodeList",
        method: "get",
        params: { syscode: "projectdoneflg" },
      });
      this.projectdoneflgList = res;
      if (
        +this.project.prsflg === 1 ||
        +this.project.prsflg === 3 ||
        +this.project.prsflg === 4 ||
        +this.project.prsflg === 5
      ) {
        let desc = res.filter((e) => {
          return +e.value === 1;
        });
        this.projectdoneflgList = res.filter(item => ['1', '4'].includes(item.value)).sort((a, b) => +a.syscodeseq - +b.syscodeseq)
        if (!this.project.projectdoneflg) {
          this.project.projectdoneflg = '1'
        }
        // this.$set(this.project, "projectdoneflg", desc[0].syscodeval);
        // this.$set(this.project, "projectdoneflgdesc", desc[0].syscodename);
      } else if (+this.project.prsflg === 2 || +this.project.prsflg === 6) {
        let desc = res.filter((e) => {
          return +e.value === 3;
        });
        this.projectdoneflgList = res.filter(item => ['3', '5'].includes(item.value)).sort((a, b) => +a.syscodeseq - +b.syscodeseq)
        if (!this.project.projectdoneflg) {
          this.project.projectdoneflg = '3'
        }
        
        // this.$set(this.project, "projectdoneflg", desc[0].syscodeval);
        // this.$set(this.project, "projectdoneflgdesc", desc[0].syscodename);
      }
    },
    async getChargefeetypeList() {
      this.chargefeetypeList = await request({
        url: "/kfgl/syscode/getSysCodeList",
        method: "get",
        params: { syscode: "chargefeetype" },
      });
    },
    async getPmList() {
      let data = await request({
        method: "get",
        url: "/basic/pm/getPmTree",
        params: { cosid: this.$store.getters.loginUser.cosid },
      });
      this.pmTreeList = data.list;
      this.pmList = data.data;
    },
    async getconfimpUserList(comid) {
      this.puserList = await request({
        method: "get",
        url: "/xtgl/user/getUserList",
        params: { comid: comid },
      });
      if (this.puserList.length > 0) {
        this.project.projectpuserid = this.puserList[0].userid;
        await this.getpUserTel(this.puserList[0].userid);
      }
    },
    async getpUserList(comid) {
      this.puserList = await request({
        method: "get",
        url: "/xtgl/user/getUserList",
        params: { comid: comid },
      });
      if (this.puserList.length > 0) {
        // this.project.projectpuserid = this.puserList[0].userid
        // await this.getpUserTel(this.project.projectpuserid);
      }
    },
    async getaUserList(comid) {
      this.auserList = await request({
        method: "get",
        url: "/xtgl/user/getUserList",
        params: { comid: comid },
      });
      // if (this.auserList.length > 0) {
      //   await this.getaUserTel(this.project.projectauserid);
      // }
    },
    async getaUserTel(userid) {
      let user = this.auserList.find((item) => item.userid === userid);
      // this.project.projectatel = this.project.projectatel?this.project.projectatel:user.username + " " + user.usertel
      this.$set(
        this.project,
        "projectatel",
        user.username + " " + user.usertel
      );
    },
    async getpUserTel(userid) {
      let user = this.puserList.find((item) => item.userid === userid);
      user.usertel = user.usertel ? user.usertel : "";
      // this.project.projectptel = this.project.projectptel?this.project.projectptel:user.username +" "+ user.usertel
      this.$set(
        this.project,
        "projectptel",
        user.username + " " + user.usertel
      );
    },
    async getPcomList() {
      let model = { cosid: this.$store.getters.loginUser.cosid, comtype: "2" };
      //代理单位
      if (this.$store.getters.loginUser.comtype === "1") {
        model.comid = null;
      }
      //采购人
      if (this.$store.getters.loginUser.comtype === "2") {
        model.comid = this.$store.getters.loginUser.usercomid;
      }
      this.pcomList = await request({
        method: "get",
        url: "/ywgl/com/getComList",
        params: model,
      });
      //业务员
      if (!this.project.projectsuserid) {
        this.$set(this.project, "projectsuserid", this.pcomList[0].comsuserid);
      }
    },
    async getAcomList() {
      let model = { cosid: this.$store.getters.loginUser.cosid, comtype: "1" };
      //代理单位
      if (this.$store.getters.loginUser.comtype === "1") {
        model.comid = this.$store.getters.loginUser.usercomid;
      }
      //采购人
      if (this.$store.getters.loginUser.comtype === "2") {
        model.comid = this.$store.getters.loginUser.usercomid;
      }
      this.acomList = await request({
        method: "get",
        url: "/ywgl/com/getComList",
        params: model,
      });
      // console.log('this.acomList[0]',this.acomList[0]);
      //业务员
      if (!this.project.projectsuserid) {
        this.$set(this.project, "projectsuserid", this.acomList[0].comsuserid);
      }
    },
    delappend(file) {
      this.$confirm(`确定移除 ${file.appendfilename}？`, "提示", {
        type: "warning",
      })
        .then(() => {
          let index = this.appendList.findIndex(
            (val) => val.appendfilename === file.appendfilename
          );
          this.appendList.splice(index, 1);
        })
        .catch(() => {});
    },
    delappend_zb(file) {
      this.$confirm(`确定移除 ${file.appendfilename}？`, "提示", {
        type: "warning",
      })
        .then(() => {
          let index = this.appendList_zb.findIndex(
            (val) => val.appendfilename === file.appendfilename
          );
          this.appendList_zb.splice(index, 1);
        })
        .catch(() => {});
    },
    async setfile(path, filename) {
      let append = {
        appendid: 0,
        appendfromid: 0,
        appendfromtype: "7",
        appendtype: "100",
        appendseq: this.appendList.length + 1,
        appendfilecode: "",
        appendfilename: filename,
        appendurl: path.replace(this.uploadAddr, ""),
      };
      this.appendList.push(append);
    },
    async setfile_zb(path, filename) {
      let append = {
        appendid: 0,
        appendfromid: 0,
        appendfromtype: "11",
        appendtype: "100",
        appendseq: this.appendList_zb.length + 1,
        appendfilecode: "",
        appendfilename: filename,
        appendurl: path.replace(this.uploadAddr, ""),
      };
      this.appendList_zb.push(append);
    },
    // 读取平台报名费收费标准并生成展示文案
    async loadFeeRules() {
      const res = await request({
        url: "/ywgl/coscomfee/getFeeRules",
        method: "get",
      });
      const list = (res && res.data) || [];
      const levelNames = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
      const rules = [];
      let lower = 0;
      for (let i = 0; i < list.length; i++) {
        const upper = list[i].upper;
        const isLast = i === list.length - 1;
        let desc = "";
        if (i === 0) {
          desc = `项目预算在${this.formatWan(upper)}以下的（不含${this.formatWan(upper)}）`;
        } else if (isLast) {
          desc = `项目预算在${this.formatWan(lower)}以上（含${this.formatWan(lower)}）`;
        } else {
          desc = `项目预算在${this.formatWan(lower)}以上（含${this.formatWan(lower)}），${this.formatWan(upper)}以下（不含${this.formatWan(upper)}）`;
        }
        rules.push({
          levelText: levelNames[i] || String(i + 1),
          desc: desc,
          amount: list[i].amount,
        });
        lower = upper;
      }
      this.bmFeeRules = rules;
    },
    // 金额转“万”表述（100000 → 10万）
    formatWan(val) {
      const n = Number(val);
      if (!n) return "0元";
      if (n >= 10000) return (n / 10000) + "万";
      return n + "元";
    },
    // 加载时判断采购人是否在“收报名费”名单；是且预算≥1000时，报名费跟随预算自动计算（静默写入）
    async loadBmFeeRule() {
      this.isBmFeePurchaser = false;
      const comid = this.project.projectpcomid;
      if (!comid) return;
      const amt = this.project.projectlimitamt ? utils.delcommafy(this.project.projectlimitamt) : 0;
      const res = await request({
        url: "/ywgl/coscomfee/getRegFee",
        method: "get",
        params: {
          cosid: this.$store.getters.loginUser.cosid,
          comid: comid,
          amt: amt,
        },
      });
      if (res && res.data) {
        this.isBmFeePurchaser = +res.data.bmfeeflg === 1;
        if (this.isBmFeePurchaser && Number(amt) >= 1000) {
          this.$set(this.project, "projectbmamt", String(res.data.bmamt == null ? 0 : res.data.bmamt));
        }
      }
    },
    // 预算变更：名单内采购人且预算≥1000时，报名费按档位规则自动更新；其它情况保持原逻辑不动
    async recalcBmamt() {
      const comid = this.project.projectpcomid;
      if (!comid) return;
      const amt = this.project.projectlimitamt ? utils.delcommafy(this.project.projectlimitamt) : 0;
      const res = await request({
        url: "/ywgl/coscomfee/getRegFee",
        method: "get",
        params: {
          cosid: this.$store.getters.loginUser.cosid,
          comid: comid,
          amt: amt,
        },
      });
      if (!(res && res.data)) return;
      this.isBmFeePurchaser = +res.data.bmfeeflg === 1;
      if (!this.isBmFeePurchaser) return;
      if (Number(amt) >= 1000) {
        this.$set(this.project, "projectbmamt", String(res.data.bmamt == null ? 0 : res.data.bmamt));
        this.$message.success("报名费已根据平台报名费收费规则，按项目预算自动更新为：" + res.data.bmamt + " 元");
      }
    },
    async addOrEdit() {
      this.btnLoading = true;

      this.submitForm("ruleForm")
        .then(async () => {
          if (!this.editorNRDesc) {
            this.$message.warning("请输入采购内容!");
            this.btnLoading = false;
            return;
          }
          this.project.prscontents = this.editorYQContent;
          this.project.projectdesc = this.editorNRDesc;
          this.project.projectmuserid = this.$store.getters.loginUser.userid;
          this.project.prsbmbegtime = utils.formatterDate(
            this.project.prsbmbegtime,
            "yyyy-MM-dd HH:mm:ss"
          );
          this.project.prsbmendtime = utils.formatterDate(
            this.project.prsbmendtime,
            "yyyy-MM-dd HH:mm:ss"
          );
          this.project.prsbjbegtime = utils.formatterDate(
            this.project.prsbjbegtime,
            "yyyy-MM-dd HH:mm:ss"
          );
          this.project.prsbjendtime = utils.formatterDate(
            this.project.prsbjendtime,
            "yyyy-MM-dd HH:mm:ss"
          );
          this.project.projectlimitamt = utils.delcommafy(
            this.project.projectlimitamt
          );
          this.project.projectbmamt = utils.delcommafy(
            this.project.projectbmamt
          );
          this.project.projectbzjamt = utils.delcommafy(
            this.project.projectbzjamt
          );
          if (this.project.prschangefee) {
            this.project.prschangefee = utils.delcommafy(
              this.project.prschangefee
            );
          }
          this.project.projectneedhost =
            this.project.projectneedhost === true ? "1" : "0";
          this.project.prsbmneedconfirm =
            this.project.prsbmneedconfirm === true ? "1" : "2";

          this.project.projectjjfile =
            this.project.projectjjfile === true ? 1 : 0;
          this.project.projectisqcheck =
            this.project.projectisqcheck === true ? 1 : 2;
          this.project.projectjjreportflg =
            this.project.projectjjreportflg === true ? 1 : 0;

          this.project.projectysflg =
            this.project.projectysflg === true ? "1" : "0";
          this.project.projecthsflg =
            this.project.projecthsflg === true ? "1" : "0";
          this.project.projectpricelistflag = 1; //报价一览表是否公开(0：不公开；1：公开)说明：投标或竞价，报价一览表是否向供应商公开阅读。
          this.project.appends = this.appendList;
          this.project.appendfromtype = 7;
          this.project.appendfromtype_zb = 11;
          this.project.projectdelaypricepermite = this.project.projectdelaypricepermite === true ? 0 : 1
          if (this.appendList_zb.length) {
            this.project.appends = this.project.appends.concat(
              this.appendList_zb
            );
          }
          // if(+this.project.projectdoneflg === 3){
          //   this.project.projectisqcheck = 1
          // }
          this.$set(this.project, 'projectpfvisible', +this.projectpfvisibleVal)
          let data = await request({
            url: "/xmgl/project/addOrEdit",
            method: "post",
            data: this.project,
          });

          if (data.issuccess === 1) {
            this.close();
            this.$refs["ruleForm"].resetFields();
            this.$message.success("保存成功");
          } else {
            this.$message.error("保存失败");
          }
        })
        .catch((err) => {
          console.log("======err======", err);
        });
      this.btnLoading = false;
    },
    close() {
      this.$store.commit("close_tab", {
        routeName: this.$route.name,
        vm: this,
        newRouteName: "projectIndex",
      });
    },
    valiway(rule, val, callback) {
      if (!val) {
        callback(Error(`不能为空`));
      } else {
        callback();
      }
    },
    validateBZJ(rule, val, callback) {
      val = utils.delcommafy(val);
      this.project.projectlimitamt = utils.delcommafy(
        this.project.projectlimitamt
      );

      let persent =
        (Number(this.project.projectlimitamt) *
          Number(this.cosInfo.coslimitamtprecent)) /
        100;
      if (Number(this.cosInfo.coslimitamtprecent) > 0) {
        if (val > persent) {
          this.bzjistshow = false;
          callback(
            Error(`保证金不能大于项目预算的${this.cosInfo.coslimitamtprecent}%`)
          );
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    async getcomsuserList() {
      let query = {
        comid: this.$store.getters.loginUser.usercomid,
      };
      let res = await request({
        method: "get",
        url: "/xtgl/user/getPageList",
        params: query,
      });
      console.log(res);
      this.comsuserList = res.list;
    },
    async getcomList() {
      //获取公司信息
      let data = await request({
        method: "get",
        url: "/xtgl/user/getUser",
        params: { userid: this.$store.getters.loginUser.userid },
      });
      this.comList = data[0];
      if (!this.project.projectid) {
        this.project.projectbidaddr = this.comList.comaddr;
      }
    },
    //获取地区list
    async getareaList() {
      let res = await request({
        method: "get",
        url: "/xtgl/dpt/getDptareaList",
        params: { cosid: this.$store.getters.loginUser.cosid },
      });
      this.areaList = res;
    },
    changeArea(value) {
      this.project.projectnoticeareacode = value;
      this.$forceUpdate();
    },
    inputchange(e) {
      this.comname = e.replace(/[, ]/g, "");
    },
    //获取协议
    async getPtcInfo(ptcid) {
      let res = await request({
        method: "get",
        url: "/xmgl/ptc/getptcInfo",
        params: { ptcid: ptcid },
      });
      this.ptcInfo = res;
    },
    sqcheckChange(e) {
      if (e) {
        this.project.projectjjfile = e;
      }
    },
  },
  watch: {
    async dialogShowpdemandrec (newVal) {
      if (newVal) {
        await this.getDemandrecList()
      }
    },
  },
};
</script>

<style lang="scss">
  .projectNameInput {
    .el-input__suffix {
      right: -50px !important;
    }
  }
  .projectdelaypricepermite{
    width: 240px;
    margin-left: -6px;
    .el-form-item__label {
      width: 210px !important;
    }
}
</style>
<style lang="scss" scoped>
@import "../../styles/filelist";

.main {
  .from_input .el-input,
  .el-input .el-input__inner,
  .el-select {
    width: 200px;
  }
  .content-title {
    display: flex;
    .el-input {
      width: 525px;
    }
    .el-cascader {
      width: 200px;
    }
  }
  .content .el-textarea__inner,
  .el-textarea,
  .el-input {
    width: 860px;
  }
  .el-checkbox:last-of-type {
    margin-left: 0px;
  }
  .file {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    // width: 50%;
    .uploadbtn {
      display: flex;
      span {
        padding-left: 10px;
        color: red;
      }
    }
  }
  .supplynums {
    display: flex;
    font-size: 12px;
    line-height: 15px;
    flex-direction: column;
  }
  .checkbox_w {
    width: 45px;
  }
}
.mainfrom .el-input {
  line-height: 0;
}
</style>
